import { Link } from 'react-router-dom';
import { MessageCircle, Heart } from 'lucide-react';

const WHATSAPP_SUPPORT = "573206313258";

// Social media icons (using SVG for better quality)
const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

export function Footer() {
  const openWhatsApp = () => {
    const message = encodeURIComponent(
      `Hola TuPrima 👋\n\nTengo una consulta sobre mi solicitud de devolución.`
    );
    window.open(`https://wa.me/${WHATSAPP_SUPPORT}?text=${message}`, '_blank');
  };

  return (
    <footer className="bg-slate-900 text-white mt-auto">
      {/* Main Footer Content */}
      <div className="max-w-md mx-auto px-6 py-8">
        {/* Contact for Refunds */}
        <div className="mb-8 text-center">
          <p className="text-xs text-slate-400 mb-3">Atención para devoluciones</p>
          <button 
            onClick={openWhatsApp}
            className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-full text-sm font-medium transition-colors"
          >
            <MessageCircle className="w-4 h-4" />
            WhatsApp: 320 631 3258
          </button>
        </div>

        {/* Social Media */}
        <div className="mb-8">
          <p className="text-xs text-slate-400 text-center mb-4">Síguenos en redes</p>
          <div className="flex items-center justify-center gap-4">
            <a 
              href="https://www.tiktok.com/@lasuertedetuprima" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 bg-slate-800 hover:bg-slate-700 rounded-full flex items-center justify-center transition-colors"
              aria-label="TikTok"
            >
              <TikTokIcon />
            </a>
            <a 
              href="https://www.instagram.com/lasuertedetuprima/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 bg-gradient-to-br from-purple-600 to-pink-500 hover:opacity-90 rounded-full flex items-center justify-center transition-opacity"
              aria-label="Instagram"
            >
              <InstagramIcon />
            </a>
            <a 
              href="https://www.facebook.com/ttuprima/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 bg-blue-600 hover:bg-blue-700 rounded-full flex items-center justify-center transition-colors"
              aria-label="Facebook"
            >
              <FacebookIcon />
            </a>
          </div>
        </div>

        {/* Legal Links */}
        <div className="flex items-center justify-center gap-4 text-xs text-slate-400 mb-6">
          <Link to="/terms" className="hover:text-white transition-colors">
            Términos y Condiciones
          </Link>
          <span>•</span>
          <Link to="/transparencia" className="hover:text-white transition-colors">
            Transparencia
          </Link>
        </div>

        {/* Brand */}
        <div className="text-center">
          <p className="text-sm font-semibold text-emerald-400 mb-1">TuPrima</p>
          <p className="text-xs text-slate-500">La que alegra el día</p>
          <a 
            href="mailto:contacto@tuprima.com" 
            className="text-xs text-emerald-400 hover:text-emerald-300 transition-colors mt-2 inline-block"
          >
            contacto@tuprima.com
          </a>
          <p className="text-xs text-slate-600 mt-2">
            © {new Date().getFullYear()} TuPrima. Todos los derechos reservados.
          </p>
        </div>

        {/* Message */}
        <div className="mt-6 pt-6 border-t border-slate-800 text-center">
          <div className="flex items-center justify-center gap-2 text-slate-400 text-sm">
            <Heart className="w-4 h-4 text-pink-400" />
            <span>Volveremos más fuertes</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
